"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionToBeReplaced = exports.ChangeFlightType = exports.FlightChangeProcessingStatus = exports.TripLink = exports.BookingConfirmationStatus = exports.CredentialTypeEnum = exports.OfferStatus = exports.ServiceType = exports.BookingStatus = exports.NavanStatus = exports.BookingFeeStatus = exports.EmailType = exports.IndicationStatus = exports.IndicationRewardStatus = exports.JustificationPolicy = exports.CabinClass = exports.DealOwnerEnum = exports.SuppliersEnum = exports.RentabilityTypeEnum = exports.TravelCustomFieldEnum = void 0;
var TravelCustomFieldEnum;
(function (TravelCustomFieldEnum) {
    TravelCustomFieldEnum["TRIP_PURPOSE"] = "TRIP_PURPOSE";
    TravelCustomFieldEnum["HOTEL_PURPOSE"] = "HOTEL_PURPOSE";
    TravelCustomFieldEnum["FLIGHT_PURPOSE"] = "FLIGHT_PURPOSE";
})(TravelCustomFieldEnum = exports.TravelCustomFieldEnum || (exports.TravelCustomFieldEnum = {}));
var RentabilityTypeEnum;
(function (RentabilityTypeEnum) {
    RentabilityTypeEnum["MARK_UP"] = "MARK_UP";
    RentabilityTypeEnum["MARGIN"] = "MARGIN";
})(RentabilityTypeEnum = exports.RentabilityTypeEnum || (exports.RentabilityTypeEnum = {}));
var SuppliersEnum;
(function (SuppliersEnum) {
    SuppliersEnum["SKYTEAM"] = "skyteam";
    SuppliersEnum["AZUL"] = "azul";
    SuppliersEnum["TTECH"] = "tech-travel";
})(SuppliersEnum = exports.SuppliersEnum || (exports.SuppliersEnum = {}));
var DealOwnerEnum;
(function (DealOwnerEnum) {
    DealOwnerEnum["AGENCY"] = "AGENCY";
    DealOwnerEnum["CUSTOMER"] = "CUSTOMER";
    DealOwnerEnum["PUBLIC"] = "PUBLIC";
})(DealOwnerEnum = exports.DealOwnerEnum || (exports.DealOwnerEnum = {}));
var CabinClass;
(function (CabinClass) {
    CabinClass["ECONOMY"] = "economy";
    CabinClass["PREMIUM_ECONOMY"] = "premium_economy";
    CabinClass["BUSINESS"] = "business";
    CabinClass["FIRST"] = "first";
})(CabinClass = exports.CabinClass || (exports.CabinClass = {}));
var JustificationPolicy;
(function (JustificationPolicy) {
    JustificationPolicy["ALWAYS"] = "ALWAYS";
    JustificationPolicy["OUTSIDE_POLICY"] = "OUTSIDE_POLICY";
    JustificationPolicy["ALWAYS_ON_APPROVAL"] = "ALWAYS_ON_APPROVAL";
    JustificationPolicy["OUTSIDE_POLICY_ON_APPROVAL"] = "OUTSIDE_POLICY_ON_APPROVAL";
    JustificationPolicy["NEVER"] = "NEVER";
})(JustificationPolicy = exports.JustificationPolicy || (exports.JustificationPolicy = {}));
var IndicationRewardStatus;
(function (IndicationRewardStatus) {
    IndicationRewardStatus["UNAVAILABLE"] = "UNAVAILABLE";
    IndicationRewardStatus["ALMOST_READY"] = "ALMOST_READY";
    IndicationRewardStatus["READY"] = "READY";
    IndicationRewardStatus["RESERVED"] = "RESERVED";
    IndicationRewardStatus["USED"] = "USED";
    IndicationRewardStatus["DROPPED"] = "DROPPED";
})(IndicationRewardStatus = exports.IndicationRewardStatus || (exports.IndicationRewardStatus = {}));
var IndicationStatus;
(function (IndicationStatus) {
    IndicationStatus["IN_NEGOTIATION"] = "IN_NEGOTIATION";
    IndicationStatus["CONVERTED"] = "CONVERTED";
    IndicationStatus["REWARD_REACHED"] = "REWARD_REACHED";
    IndicationStatus["NOT_REACHED"] = "NOT_REACHED";
})(IndicationStatus = exports.IndicationStatus || (exports.IndicationStatus = {}));
var EmailType;
(function (EmailType) {
    EmailType["INVITE_EVENT"] = "INVITE_EVENT";
    EmailType["UPDATE_EVENT"] = "UPDATE_EVENT";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var BookingFeeStatus;
(function (BookingFeeStatus) {
    BookingFeeStatus["NONE"] = "NONE";
    BookingFeeStatus["UNITIATED"] = "UNITIATED";
    BookingFeeStatus["PENDING"] = "PENDING";
    BookingFeeStatus["PAID"] = "PAID";
    BookingFeeStatus["FAILED"] = "FAILED";
})(BookingFeeStatus = exports.BookingFeeStatus || (exports.BookingFeeStatus = {}));
var NavanStatus;
(function (NavanStatus) {
    NavanStatus["UNITIATED"] = "UNITIATED";
    NavanStatus["EXPORTED"] = "EXPORTED";
    NavanStatus["FAILED"] = "FAILED";
})(NavanStatus = exports.NavanStatus || (exports.NavanStatus = {}));
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["UNITIATED"] = "UNITIATED";
    BookingStatus["PENDING"] = "PENDING";
    BookingStatus["FAILED"] = "FAILED";
    BookingStatus["DROPPED"] = "DROPPED";
    BookingStatus["EMITTED"] = "EMITTED";
})(BookingStatus = exports.BookingStatus || (exports.BookingStatus = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["FLIGHT"] = "flight";
    ServiceType["HOTEL"] = "hotel";
    ServiceType["CAR"] = "car";
    ServiceType["BUS"] = "bus";
    ServiceType["RIDE"] = "ride";
    ServiceType["SMARTRIPS"] = "smartrips";
    ServiceType["INSURANCE"] = "insurance";
    ServiceType["RAIL"] = "rail";
    ServiceType["TRANSFER"] = "transfer";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var OfferStatus;
(function (OfferStatus) {
    OfferStatus["APPROVAL_DECLINED"] = "APPROVAL_DECLINED";
    OfferStatus["BOOKING_FAILED"] = "BOOKING_FAILED";
    OfferStatus["DRAFT"] = "DRAFT";
    OfferStatus["BOOKING_PROCESSING"] = "BOOKING_PROCESSING";
    OfferStatus["CANCELING"] = "CANCELING";
    OfferStatus["EMITTED"] = "EMITTED";
    OfferStatus["CANCELED"] = "CANCELED";
})(OfferStatus = exports.OfferStatus || (exports.OfferStatus = {}));
var CredentialTypeEnum;
(function (CredentialTypeEnum) {
    CredentialTypeEnum["AGENCY"] = "AGENCY";
    CredentialTypeEnum["GENERAL"] = "GENERAL";
    CredentialTypeEnum["CUSTOMER"] = "CUSTOMER";
})(CredentialTypeEnum = exports.CredentialTypeEnum || (exports.CredentialTypeEnum = {}));
var BookingConfirmationStatus;
(function (BookingConfirmationStatus) {
    BookingConfirmationStatus["CONFIRMED"] = "CONFIRMED";
    BookingConfirmationStatus["FAILED"] = "FAILED";
    BookingConfirmationStatus["NOT_SURE"] = "NOT_SURE";
})(BookingConfirmationStatus = exports.BookingConfirmationStatus || (exports.BookingConfirmationStatus = {}));
var TripLink;
(function (TripLink) {
    TripLink["CONNECTION"] = "connection";
    TripLink["DIRECT"] = "direct";
})(TripLink = exports.TripLink || (exports.TripLink = {}));
var FlightChangeProcessingStatus;
(function (FlightChangeProcessingStatus) {
    FlightChangeProcessingStatus["UNITIATED"] = "UNITIATED";
    FlightChangeProcessingStatus["PENDING"] = "PENDING";
    FlightChangeProcessingStatus["SUCCESS"] = "SUCCESS";
    FlightChangeProcessingStatus["FAILED"] = "FAILED";
})(FlightChangeProcessingStatus = exports.FlightChangeProcessingStatus || (exports.FlightChangeProcessingStatus = {}));
var ChangeFlightType;
(function (ChangeFlightType) {
    ChangeFlightType["ONE_WAY"] = "ONE_WAY";
    ChangeFlightType["ROUND_TRIP"] = "ROUND_TRIP";
    ChangeFlightType["RETURN"] = "RETURN";
})(ChangeFlightType = exports.ChangeFlightType || (exports.ChangeFlightType = {}));
var SectionToBeReplaced;
(function (SectionToBeReplaced) {
    SectionToBeReplaced["OUTBOUND"] = "OUTBOUND";
    SectionToBeReplaced["INBOUND"] = "INBOUND";
})(SectionToBeReplaced = exports.SectionToBeReplaced || (exports.SectionToBeReplaced = {}));
